import { format } from "date-fns";
import { getSortByObjectKey } from "../getSortByObjectKey";

export const getEventLogData = (events) => {
  // Sort the events into a single array
  let formattedEvents = [];

  // Bathroom
  if (events?.["bathroom.wall.motion"]) {
    formattedEvents = formattedEvents.concat(
      events?.["bathroom.wall.motion"]?.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "bathroom",
      }))
    );
  }
  if (events?.["hall.wall.motion"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.wall.motion"]?.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "movement",
      }))
    );
  }
  if (events?.["kitchen.fridge.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["kitchen.fridge.door"]?.openedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "fridge",
      }))
    );
  }

  /// Front door
  if (events?.["hall.front.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.front.door"]?.openedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "door opened",
      }))
    );
  }

  if (events?.["hall.front.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.front.door"]?.closedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "door closed",
      }))
    );
  }

  // Main door
  if (events?.["hall.main.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.main.door"]?.openedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "door opened",
      }))
    );
  }

  if (events?.["hall.main.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.main.door"]?.closedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "door closed",
      }))
    );
  }

  // Back door
  if (events?.["hall.secondary.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.secondary.door"]?.openedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "back door opened",
      }))
    );
  }

  if (events?.["hall.secondary.door"]) {
    formattedEvents = formattedEvents.concat(
      events?.["hall.secondary.door"]?.closedAt.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "back door closed",
      }))
    );
  }

  if (events?.["bedroom.wall.motion"]) {
    formattedEvents = formattedEvents.concat(
      events?.["bedroom.wall.motion"]?.map((eventTime) => ({
        startedAt: eventTime,
        timePeriod: format(new Date(eventTime), "h:mmaaa"),
        type: "bedroom motion",
      }))
    );
  }

  // Sort the combined events by time
  const sortedEvents = getSortByObjectKey(formattedEvents, "startedAt");

  return {
    allMotionEvents: sortedEvents || [],
  };
};
